export class TableDataPayload<Item> {
  public constructor(
    public readonly data: Item[],
    public readonly size: number,
    public readonly page: number,
    public readonly total: number,
  ) {}

  public get first(): number {
    return (this.page - 1) * this.size;
  }
}
